
























































































































import http from "@/axios/http-common";
import { resepStore } from "@/store/modules/resep";
import { sum, map, debounce } from "lodash";
import { Vue, Component, Watch, Ref, Prop } from "vue-property-decorator";
import ObatItemRow from "../resep/ObatItemRow.vue";
import ObatRacikanRow from "../resep/ObatRacikanRow.vue";
import { appModule } from "@/store/modules/app";

interface ObatSingle {
  type: "single";
  nama: string;
  qty: number;
  satuan: string;
  signa: string;
  harga: number;
  countedHarga: number;
}

interface ObatRacikan {
  type: "racikan";
  obat: Array<any>;
  sediaan: string;
  qty: string;
  signa: string;
}

const currencyFormatter = new Intl.NumberFormat("id-ID", {
  style: "currency",
  currency: "IDR"
});

@Component({
  components: {
    ObatItemRow,
    ObatRacikanRow
  }
})
export default class CardResepInputGuided extends Vue {
  public entries: Array<{
    label: string;
    nama: string;
    id: string;
    satuan: string;
    harga: string | number;
    stock_qty: number;
    restriksi: string;
  }> = [];
  public isLoading = false;
  public model = null;
  public search = null;
  // public items: Array<ItemObat> = [];
  public items: Array<ObatSingle | ObatRacikan> = [];
  public count = 0;
  public totalHarga = 0;
  public _timerId;
  public addBtnLoading = false;

  @Prop() showed: boolean;

  get depoId() {
    return resepStore.depoId;
  }

  get obatList() {
    return this.entries
      .sort((a, b) => {
        if (a.stock_qty === 0 && b.stock_qty !== 0) {
          return 1;
        } else if (a.stock_qty !== 0 && b.stock_qty === 0) {
          return -1;
        } else if (a.nama === b.nama) {
          return b.stock_qty - a.stock_qty;
        } else {
          return a.nama.localeCompare(b.nama);
        }
      })
      .map((it, idx) => {
        it["index"] = idx;
        return it;
      });
  }

  mounted() {
    this.$nextTick(() => {
      this.$nextTick(() => {
        this.focusToSearch();
      });
    });
  }

  @Watch("showed")
  changedShowed(show: boolean) {
    if (show) {
      this.$nextTick(() => {
        this.$nextTick(() => {
          this.focusToSearch();
        });
      });
    }
  }

  @Ref() readonly searchBox!: HTMLInputElement;

  validateItems() {
    const fieldsQty = this.items.filter(item => {
      return item.qty;
    });

    const fieldsSigna = this.items.filter(item => {
      return item.signa;
    });

    const obatRacikanEmpty = this.items.filter(item => {
      return item.type == "racikan" && item.obat.length < 1;
    });

    if (obatRacikanEmpty.length) {
      appModule.sendErrorAlert(
        "Mohon maaf, ada obat racikan yang komponen obatnya masih kosong"
      );

      return false;
    }

    if (
      fieldsQty.length != this.items.length ||
      fieldsSigna.length != this.items.length
    ) {
      appModule.sendErrorAlert(
        "Mohon maaf, ada kolom jumlah atau signa yang belum diisi"
      );

      return false;
    }

    return true;
  }

  itemColor(index) {
    return index % 2 === 0 ? "grey lighten-3" : "";
  }

  focusToSearch() {
    this.searchBox.focus();
  }

  selectObat(val) {
    if (!val.stock_qty) {
      const q = confirm(
        `Obat/Alkes yang Anda pilih (${val.nama}) tidak ada stok tersedia. Tetap lanjut?`
      );

      const kw = this.search;

      if (!q) {
        this.entries = [];
        this.searchBox.focus();

        setTimeout(() => {
          this.search = kw;
        }, 100);

        return;
      }
    }

    this.search = null;
    this.entries = [];
    this.addObatSingle(val);

    this.$nextTick(() => {
      this.searchBox.blur();
    });
  }

  renderStock(data) {
    return data.stock_qty !== null ? data.stock_qty : "n/a";
  }

  renderRestriksi(data) {
    return data.restriksi
      ? `Restriksi ${data.nama} : <br/>` + data.restriksi
      : "";
  }

  @Watch("search")
  changedSearch() {
    this.entries = [];

    clearTimeout(this._timerId);

    this._timerId = setTimeout(() => {
      if (this.search === null || this.search.length < 3) return;

      this.isLoading = true;

      http
        .getDataParam("/referensi/obat/search", {
          params: { term: this.search, depo: this.depoId }
        })
        .then(res => {
          this.entries = res.data;
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => (this.isLoading = false));
    }, 500);
  }

  searchInputAutocomplete() {
    debounce(e => {
      console.log(e);
      console.log("debounce");
    }, 500);
  }

  close() {
    this.clearFields();
    this.$emit("close");
  }

  clearFields() {
    this.search = "";
    this.entries = [];
    this.items = [];
    this.totalHarga = 0;
  }

  submitItems() {
    this.addBtnLoading = true;
    const print = [];

    const valid = this.validateItems();

    if (!valid) {
      this.addBtnLoading = false;
      return false;
    }

    this.items.forEach(item => {
      if (item.type === "single") {
        print.push(`R/ ${item.nama} No. ${item.qty} \r\n    ${item.signa}`);
      } else if (item.type === "racikan") {
        const obat = item.obat
          .map(obat => {
            return `${obat.nama} No.${obat.qty} ${obat.satuan}`;
          })
          .join(`;\r\n    `);

        print.push(
          `R/ ${obat}\r\n    ${item.sediaan} No. ${item.qty}\r\n    ${item.signa}`
        );
      }
    });

    // rencananya buat simpan signa kalo ada signa baru

    // kasih loader biar seakan2 load data
    setTimeout(() => {
      this.addBtnLoading = false;

      this.$emit("generateResepText", print.join(`\r\n`));
      this.close();
    }, 300);
  }

  sumTotalHarga() {
    this.totalHarga = sum(map(this.items, "countedHarga"));
  }

  formatHarga(harga) {
    return currencyFormatter.format(harga);
  }

  addObatSingle(obat = null) {
    if (obat) {
      this.items.push({
        type: "single",
        nama: obat.nama,
        qty: null,
        satuan: obat.satuan,
        signa: "",
        harga: obat.harga,
        countedHarga: null
      });
    } else {
      this.items.push({
        type: "single",
        nama: "",
        qty: null,
        satuan: "",
        signa: "",
        harga: null,
        countedHarga: null
      });
    }
  }

  addObatRacikan() {
    this.items.push({
      type: "racikan",
      obat: [],
      sediaan: "",
      qty: null,
      signa: ""
    });
  }

  removeItem(idx) {
    this.items.splice(idx, 1);
    this.sumTotalHarga();
  }

  showWarningModal(item) {
    alert("Restriksi: \r\n" + item.restriksi);
  }

  itemHighlightedIdx = null;

  listItemIndexUpdated(val) {
    this.itemHighlightedIdx = val;
  }
}
